import React from "react";
interface SakuraProps {
  className?: string;
}
export function Sakura({
  className = "h-4 w-4"
}: SakuraProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" data-id="element-312" data-mp="gu4x8mrbum60">
      <g fill="currentColor" data-id="element-313" data-mp="bt7fgba8bu51">
        {[0, 72, 144, 216, 288].map(r => <path key={r} transform={`rotate(${r} 12 12)`} d="M12 12c-1.8-2.2-2.6-4.6-1.6-6.6.4-.8 1-1.3 1.6-1.6.6.3 1.2.8 1.6 1.6 1 2-.2 4.4-1.6 6.6z" data-id="element-314" data-mp="6unuoe7dgoe9" />)}
      </g>
      <circle cx="12" cy="12" r="1.3" fill="#B69A68" data-id="element-315" data-mp="3u76mkbkx2pbn" />
    </svg>;
}
interface FujiProps {
  className?: string;
}
export function FujiLine({
  className = ""
}: FujiProps) {
  return <svg viewBox="0 0 600 180" className={className} aria-hidden="true" fill="none" data-id="element-316" data-mp="3k9sizck3dv0r">
      <circle cx="430" cy="62" r="34" fill="#E6C7C1" opacity="0.7" data-id="element-317" data-mp="3k7pmc9ofp3n2" />
      <path d="M40 170 L250 40 Q262 32 274 40 L560 170" stroke="#314957" strokeWidth="1.2" opacity="0.35" data-id="element-318" data-mp="3f9xpd18xmrc0" />
      <path d="M216 62 L250 40 Q262 32 274 40 L310 62 L292 70 L276 60 L262 72 L246 60 L230 70 Z" fill="#314957" opacity="0.12" data-id="element-319" data-mp="3b9nkxt0sg8z9" />
      <path d="M0 170 Q120 150 220 168 T440 162 T600 168" stroke="#314957" strokeWidth="1" opacity="0.25" data-id="element-320" data-mp="34cuv08wt2zdd" />
    </svg>;
}
export function Divider() {
  return <div className="flex items-center justify-center gap-3 text-sakura" aria-hidden="true" data-id="element-321" data-mp="2pprvxxsu4inx">
      <span className="h-px w-16 bg-dorado/50" data-id="element-322" data-mp="2unkxgdj70ohv" />
      <Sakura className="h-4 w-4 text-sakura" data-id="element-323" data-mp="3icvupl1c40r9" />
      <span className="h-px w-16 bg-dorado/50" data-id="element-324" data-mp="3id5ir32tjxub" />
    </div>;
}